module.exports = __webpack_public_path__ + "img/service-order.0387d12c.svg";